import { useRouter } from 'next/router';
import { nextPreload, useTranslation } from '@fanfanlo';
import { styled } from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import ListIcon from '@mui/icons-material/List';
import { BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import React from 'react';

const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0 -2px 12px rgba(0, 0, 0, 0.08)',
  height: 72,
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  '& .Mui-selected': {
    color: theme.palette.primary.main,
    '& .MuiBottomNavigationAction-label': {
      fontSize: '0.75rem',
      fontWeight: 600,
      marginTop: '4px',
    },
  },
  '& .MuiBottomNavigationAction-root': {
    minWidth: 'auto',
    padding: '8px 12px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
    '& .MuiBottomNavigationAction-label': {
      fontSize: '0.7rem',
      opacity: 0.9,
      transition: 'all 0.2s ease',
    },
  },
}));

interface TabInfoType {
  label: string;
  value: string;
  icon: React.ReactNode;
}

export function NavBar() {
  const router = useRouter();
  const { pathname } = router;
  const { t } = useTranslation('emergency-call/components/navbar/content');
  const tabInfoList: TabInfoType[] = [
    { label: t('NavBar.home'), value: '/', icon: <HomeIcon /> },
    { label: t('NavBar.settings'), value: '/settings', icon: <SettingsIcon /> },
  ];

  React.useEffect(() => {
    nextPreload(router, '/settings')
    nextPreload(router, '/')
  }, [])

  return (
    <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
      <StyledBottomNavigation 
        showLabels 
        value={pathname}
        onChange={(_, newValue) => {
          if (pathname !== newValue) {
            router.push(newValue);
          }
        }}
      >
        {tabInfoList.map((e) => {
          const isSelected = pathname === e.value;
          return (
            <BottomNavigationAction
              key={e.value}
              value={e.value}
              label={e.label}
              icon={
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '6px 0',
                  }}
                >
                  {e.icon}
                </Box>
              }
              data-id={`tabbar-${e.value}`}
              sx={{
                minWidth: 'auto',
                '&.Mui-selected': {
                  color: (theme) => theme.palette.primary.main,
                  '& .MuiSvgIcon-root': {
                    transform: 'scale(1.1)',
                  },
                },
                '& .MuiSvgIcon-root': {
                  fontSize: '1.6rem',
                  marginBottom: '2px',
                  transition: 'transform 0.2s ease',
                },
              }}
            />
          );
        })}
      </StyledBottomNavigation>
    </Box>
  );
}